"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var markdown_service_1 = require("./markdown.service");
var MarkdownPipe = /** @class */ (function () {
    function MarkdownPipe(markdownService, zone) {
        this.markdownService = markdownService;
        this.zone = zone;
    }
    MarkdownPipe.prototype.transform = function (value) {
        var _this = this;
        if (typeof value !== 'string') {
            console.error("MarkdownPipe has been invoked with an invalid value type [" + value + "]");
            return value;
        }
        var markdown = this.markdownService.compile(value);
        this.zone.runOutsideAngular(function () {
            // glitch in the UI... need a better way to handle this!
            setTimeout(function () { return _this.markdownService.highlight(); });
        });
        return markdown;
    };
    MarkdownPipe.decorators = [
        { type: core_1.Pipe, args: [{
                    name: 'markdown',
                },] },
    ];
    /** @nocollapse */
    MarkdownPipe.ctorParameters = function () { return [
        { type: markdown_service_1.MarkdownService, },
        { type: core_1.NgZone, },
    ]; };
    return MarkdownPipe;
}());
exports.MarkdownPipe = MarkdownPipe;
//# sourceMappingURL=markdown.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-markdown/dist/lib/markdown.pipe.js
// module id = ./node_modules/ngx-markdown/dist/lib/markdown.pipe.js
// module chunks = vendor